export const PRIVACY_EMAIL = '61@61imoveis.com';
export const CONSENT_KEY = '61:privacy:v1';
// A página de privacidade pede a abertura do painel por evento; a escolha continua morando
// num lugar só (PrivacyPreferences), sem estado duplicado entre telas.
export const OPEN_EVENT = '61:privacy:open';

export function openPreferences() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}
const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
const GA_ID = 'G-SEC4Q9LZCL';

export function readConsent() {
  try {
    const value = JSON.parse(localStorage.getItem(CONSENT_KEY));
    if (typeof value?.analytics !== 'boolean' || !Number.isFinite(value.at) ||
        value.at > Date.now() || Date.now() - value.at > MAX_AGE) return null;
    return value;
  } catch { return null; }
}

export function clearAnalyticsCookies() {
  const parts = window.location.hostname.split('.');
  const domains = ['', ...parts.map((_, i) => `; domain=${parts.slice(i).join('.')}`)];
  document.cookie.split(';').forEach(cookie => {
    const name = cookie.split('=')[0].trim();
    if (/^(_ga|_gid|_gat)(_|$)/.test(name)) {
      domains.forEach(domain => {
        document.cookie = `${name}=; Max-Age=0; path=/${domain}; SameSite=Lax`;
      });
    }
  });
}

export function saveConsent(analytics) {
  const choice = { analytics, at: Date.now() };
  // If storage is unavailable, do not enable tracking without a saved preference.
  localStorage.setItem(CONSENT_KEY, JSON.stringify(choice));
  window[`ga-disable-${GA_ID}`] = !analytics;
  if (!analytics) clearAnalyticsCookies();
  return choice;
}

export function startAnalytics() {
  // Analytics is confined to the public home; never send internal routes or query data.
  if (!readConsent()?.analytics || window.location.pathname !== '/') return;
  window[`ga-disable-${GA_ID}`] = false;
  if (document.getElementById('privacy-analytics')) return;
  // Stop before GA can observe history changes, not after React renders the next route.
  ['pushState', 'replaceState'].forEach(method => {
    const original = window.history[method].bind(window.history);
    window.history[method] = (...args) => {
      stopAnalytics();
      return original(...args);
    };
  });
  window.addEventListener('popstate', stopAnalytics, true);
  window.addEventListener('hashchange', stopAnalytics, true);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    analytics_storage: 'granted', ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied',
  });
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, {
    send_page_view: false, allow_google_signals: false,
    allow_ad_personalization_signals: false,
    cookie_expires: MAX_AGE / 1000, cookie_update: false,
    page_location: `${window.location.origin}/`, page_referrer: '',
    page_title: 'Inteligência Imobiliária',
  });
  window.gtag('event', 'page_view', {
    page_location: `${window.location.origin}/`, page_referrer: '',
    page_title: 'Inteligência Imobiliária',
  });
  const script = document.createElement('script');
  script.id = 'privacy-analytics';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function stopAnalytics() {
  window[`ga-disable-${GA_ID}`] = true;
}
